import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/api/client";
import ProductCard from "@/components/ProductCard";

export default function Category() {
  const { slug } = useParams();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categoryName, setCategoryName] = useState("");

  useEffect(() => {
    setLoading(true);
    api.get(`/products?category=${slug}`).then((r) => setProducts(r.data)).finally(() => setLoading(false));
    api.get("/categories").then((r) => {
      const cat = r.data.find((c) => c.slug === slug);
      setCategoryName(cat?.name || slug);
    });
  }, [slug]);

  return (
    <div className="mx-auto max-w-7xl px-4 lg:px-8 py-10" data-testid="category-page">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-[0.2em] text-[#F48E2E] font-bold mb-2">Category</div>
        <h1 className="font-display text-4xl md:text-5xl">{categoryName}</h1>
      </div>
      {loading ? (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[...Array(8)].map((_, i) => <div key={i} className="aspect-[4/5] bg-gray-100 rounded-2xl animate-pulse" />)}
        </div>
      ) : products.length === 0 ? (
        <div className="text-center py-20 text-gray-500">No products live in this category right now. Listings stay live for 24 hours — vendors renew them to bring them back, so check again soon!</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
